import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
    apiKey: "AIzaSyCDuq4wElCuIG5ypXvFg2dT2Oti2s6FGEE",
    authDomain: "blog-site-c4b8d.firebaseapp.com",
    projectId: "blog-site-c4b8d",
    storageBucket: "blog-site-c4b8d.firebasestorage.app",
    messagingSenderId: "108355680450",
    appId: "1:108355680450:web:52e98dac91e815db2ea35b"
  };

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

console.log(analytics);